import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import Icon from '../../common/containers/icon';
import SearchInput from '../../common/search/searchInput';
import SinglePicker from '../../common/controls/singlePicker';
const ContractSpecsFilters = props => {
  const {
    onFilter,
    onFilterClear,
    onSearchClear,
    onSearch,
    filters: {
      text,
      active
    }
  } = props;
  const header = /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onFilterClear,
    className: "float-md-right t-filter-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")));
  const statuses = [{
    id: '1',
    name: 'Active'
  }, {
    id: '0',
    name: 'Inactive'
  }];
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    type: "text",
    text: text,
    onChange: onSearch,
    onClear: onSearchClear
  }), /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-csf-active",
    clearable: false,
    label: "Active/Inactive",
    onChange: value => onFilter('active', value),
    options: statuses,
    returnValueKey: "id",
    searchable: false,
    value: active
  })));
};
ContractSpecsFilters.propTypes = {
  onFilter: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    text: PropTypes.string,
    active: PropTypes.string
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchClear: PropTypes.func.isRequired
};
export default ContractSpecsFilters;